import * as React from 'react';

export const useEffectOnce = (effect: () => void | (() => void)) => {
  const destroyFunc = React.useRef<void | (() => void) | null>(null);
  const effectCalledRef = React.useRef(false);
  const renderAfterCalledRef = React.useRef(false);
  // Track if effect was called using state to avoid accessing ref during render
  const [effectCalled, setEffectCalled] = React.useState(false);

  // Update renderAfterCalled after effectCalled becomes true
  React.useEffect(() => {
    if (effectCalled) {
      renderAfterCalledRef.current = true;
    }
  }, [effectCalled]);

  React.useEffect(() => {
    // only execute the effect first time around
    if (!effectCalledRef.current) {
      destroyFunc.current = effect();
      effectCalledRef.current = true;
      setEffectCalled(true);
    }

    return () => {
      // if the comp didn't render since the useEffect was called,
      // we know it's the dummy React cycle
      if (!renderAfterCalledRef.current) {
        return;
      }
      if (destroyFunc.current) {
        destroyFunc.current();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
